/**
 * @Author: wuyang
 * @Date: 2024/1/10
 * @Description: ""
 */

import styles from './dataXHeader.module.scss'
import { DataXHeaderAvatar } from '@/business-component/data-x-header/DataXHeaderAvatar'
import { useLocation, useNavigate } from 'react-router-dom'
import classNames from 'classnames'
import { userinfoService } from '@/common/services/userinfo/userinfoService'
import { useAtomMethod } from '@/helper/hooks/atom-method-hook/useAtomMethod'
import { useEffect } from 'react'
import { message } from 'antd'
import { useState, useMemo } from 'react'

export const DataXHeader = () => {
	const navigate = useNavigate()
	const location = useLocation()
	const [userInfo] = useAtomMethod(userinfoService.userInfo)
	const [isVip] = useAtomMethod(userinfoService.isVip)
	const residueScoreStr = `${userInfo?.currentMode == 1 ? userInfo?.residueScore : userInfo?.team?.currentScore}积分 | ${userInfo?.packageName}`
	const showNav = location.pathname.startsWith('/workspace')


	const tabList = useMemo(() => {
		const tabs = [
			{ title: 'AI商拍', path: '/workspace', name: 'collect' },
			{ title: '素材创作', path: '/workspace/creation', name: 'creation' },
			{ title: '素材编辑', path: '/workspace/materialEdit', name: 'materialEdit' },
		];
		// 当前模式为2时添加团队工具
		if (userInfo?.currentMode === 2) {
			tabs.push({ title: '批量裂变工具', path: '/workspace/batchTools/uploadImage/index', name: 'batchTools' }, { title: '团队工具', path: '/workspace/teamTools', name: 'teamTools' });
		}

		return tabs;
	}, [userInfo?.currentMode]);

	const menuList = [
		{ title: 'AI商拍', path: '/workspace', name: 'collect' },
		{ title: '素材创作', path: '/workspace/creation', name: 'creation' },
		{ title: '素材编辑', path: '/workspace/materialEdit', name: 'materialEdit' },
		{ title: '批量裂变工具', path: '/workspace/batchTools/uploadImage/index', name: 'batchTools' },
		{ title: '团队工具', path: '/workspace/teamTools', name: 'teamTools' }
	];


	const getActiveTabIndex = () => {
		// const index = tabList.findIndex(tab => location.pathname.includes(tab.name))
		const index = menuList.findIndex(tab => location.pathname.includes(tab.name))
		return index !== -1 ? index : 0
	}
	const [active, setActive] = useState(getActiveTabIndex())

	useEffect(() => {
		setActive(getActiveTabIndex())
	}, [location.pathname])

	// useEffect(() => {
	// if (
	// 	localStorage.getItem('passwordFlag') === 'true' &&
	// 	localStorage.getItem('firstTip') === 'first'
	// ) {
	// 	message.open({
	// 		type: 'warning',
	// 		content:
	// 			'欢迎登录！您可以在会员中心设置登录密码，方便以后使用账号密码登录',
	// 		duration: 6
	// 	})

	// 	localStorage.setItem('firstTip', 'no')
	// }
	// }, [])

	const handleTab = (path: string, index: number) => {
		setActive(index)
		navigate(path)
	}
	return (
		<div className={'w-full h-[64px] flex flex-row items-center bg-white min-w-[1000px]'}>
			<div
				className={'my-[16px] pl-[14px] w-[163px] pr-[14px] cursor-pointer'}
				onClick={() => {
					navigate('/')
				}}
			>
				<img
					src={require('@/asset/image/logo.png')}
					className={'h-[30px]'}
					alt=""
				/>
			</div>
			<div className={'flex-1'}>
				{showNav ? (
					// <div className='flex items-center justify-center'>
					<div className='ml-[20%]'>
						{tabList.map((item, index) => {
							return (
								<span
									key={index}
									className={classNames(
										'text-primary font-bold relative cursor-pointer mr-[24px]',
										{ [styles.navActive]: active === index }
									)}
									onClick={() => handleTab(item.path, index)}
								>
									{item.title}
								</span>
							);
						})}
					</div>
				) : (
					<div></div>
				)}
			</div>
			{/* <div className={'w-[160px]'}>
				<span
					className={classNames(
						'cursor-pointer hover:text-primary',
						showNav ? 'text-primary' : 'text-normal'
					)}
					onClick={() => {
						navigate('/workspace')
					}}
				>
					工作台
				</span>
				<span
					className={classNames(
						'ml-[20px] cursor-pointer hover:text-primary',
						location.pathname.startsWith('/docs')
							? 'text-primary'
							: 'text-normal'
					)}
					onClick={() => {
						navigate('/docs')
					}}
				>
					教程
				</span>
			</div> */}
			<div className={'w-min-[200px] mr-[20px]'}>
				<div
					className={
						'h-[36px] rounded bg-gradient-to-r from-[#FFF8F1] to-[#F5E5D7] border border-[#F7E8DA] flex justify-between items-center px-4 cursor-pointer'
						// `h-[36px] rounded bg-gradient-to-r from-[#FFF8F1] to-[#F5E5D7] border border-[#F7E8DA] flex justify-between items-center px-4 ${userInfo?.currentMode === 1 ? 'cursor-pointer' : ''}`
					}
					onClick={() => {
						navigate('/vip')
						// if (userInfo?.currentMode === 1) {
						// window.open('/vip');
						// }
					}}
				>
					<div>
						<img
							src={
								isVip
									? require('@/asset/icon/vip-active.png')
									: require('@/asset/icon/vip-deactive.png')
							}
							alt=""
							className={'w-[18px] h-[16px] mt-[7px]'}
						/>
					</div>
					<div className={'text-[#C58349] text-[14px] ml-2'}>
						{residueScoreStr}
					</div>
				</div>
			</div>
			<div className={'w-[64px]'}>
				<DataXHeaderAvatar />
			</div>
		</div>
	)
}
